import React from 'react';
import axios from 'axios';
import { sortArrayAscendingorder } from '../Utils/CommonFunctions';
import './Home.css';
import { DetailsHeader, DetailsList, IColumn, Link, SelectionMode } from 'office-ui-fabric-react';
import { ChevronDownRegular, ChevronUpRegular } from '@fluentui/react-icons';
import { SweetAlerts } from './Global/SweetAlert';

const Terms = ({requestDetails, type}) => {
  const [showallplaceholder, setshowallplaceholder] = React.useState([]);
  const [showallcounterplaceholder, setshowallcounterplaceholder] = React.useState([]);
  const [showallOrgplaceholder, setshowallOrgplaceholder] = React.useState([]);
  const JSZip=require("jszip")
  const [visibility, setVisibility] = React.useState({
  showItems: true,
  showCounterItems: true,
  showOrgItems: true,
  });
  console.log(type)


  React.useEffect(()=>{
      const ContractTypeRowID=localStorage.getItem('ContractTypeRowID');
    if(ContractTypeRowID&&ContractTypeRowID!=="undefined"&&ContractTypeRowID!=="null"){
           fetchFormFields(ContractTypeRowID);
      }else if(requestDetails?.Contract_Type){
           fetchFormFields(requestDetails?.Contract_Type);
      }
},[])

  const customStyles = {
    root: {
      '.ms-DetailsHeader': {
         height: '34px',
      },
      '.ms-DetailsHeader-cellName': {
        marginTop: '-15px',
      },
    },
  };

  const fetchFormFields = async (ID) => {
    const SiteURL = localStorage.getItem("SiteURL");
    const token = localStorage.getItem("CurrentToken");
    const response = await axios.get(
      `${SiteURL}/_api/web/lists/getByTitle('CLM365Contract_Type')/items('${ID}')?$select=FormFields,ID,ConditionalField`,{
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json;odata=verbose",
        },
      }
    );
        const data = response.data;
        // let _JsonFormFields = JSON.parse(data.d.FormFields||"{}")?.General?.items ? JSON.parse(data.d.FormFields||"{}")?.General?.items : [];
        let _JsonFormFields = Object.values(JSON.parse(data.d.FormFields || "{}")).flatMap((i: any) => i.items || []);
        let _ConditionalField = JSON.parse(data.d.ConditionalField||"[]")
        const conditionalFields = _ConditionalField?.Drop_Down?.Choices||[]
    
        const _conditiondata = [];
        const _formfields = [
          { key: 'Contract_Type', text: 'Contract Type' },
          { key: 'Business_Unit', text: 'Business Unit' }
        ];

        conditionalFields?.map(field => {
          _conditiondata.push({
            key: field.InternalName,
            text: field.FieldName
          })
          })
        
      _JsonFormFields.filter(i => i.IntName !== "Contract_Date" && i.IntName !== "Contract_Term").map(field => {
        _formfields.push({
          key: field.IntName,
          text: field.text
        })
      });
        let counterParty = []; 
        let OrgInfo = [];
        
        counterParty.push(
          { key: "Organization_Name", text: "Organization Name" },
          { key: "Counterparty_Type", text: "Counterparty Type" },
          { key: "Counterparty_Jurisdiction", text: "Counterparty Jurisdiction" },
          { key: "Country", text: "Country" },
          { key: "State",  text: "State" },
          { key: "City", text: "City" },
          { key: "Zip_Code", text: "Zip Code" },
          { key: "Address_Line_1", text: "Address Line 1" },
          { key: "Address_Line_2", text: "Address Line 2" },
          { key: "Contact_Number", text: "Contact Number" },
          { key: "Email", text: "Email" }
        );

        OrgInfo.push(
          { key: "Organization_Title", text: "Organization Title" },
          { key: "Organization_URL", text: "Organization URL" },
          { key: "Organization_Country", text: "Organization Country" },
          { key: "Organization_State", text: "Organization State" },
          { key: "Organization_City",  text: "Organization City" },
          { key: "Organization_ZipCode", text: "Organization Zip Code"},
          { key: "Organization_Address_Line_1", text: "Organization Address Line 1" },
          { key: "Organization_Address_Line_2", text: "Organization Address Line 2" },
          { key: "Organization_Contact_Number", text: "Organization Contact Number" },
          { key: "Organization_Jurisdiction", text: "Organization Jurisdiction" },
          { key: "Organization_Currency", text: "Organization Currency" },
          { key: "Organization_Website", text: "Organization Website"}
        );
        const mergedField = [..._formfields, ..._conditiondata];
        sortArrayAscendingorder(mergedField, 'key');
        setshowallplaceholder(mergedField);
        sortArrayAscendingorder(counterParty, 'text');
        setshowallcounterplaceholder(counterParty);
        sortArrayAscendingorder(OrgInfo, 'text');
        setshowallOrgplaceholder(OrgInfo);
  };
  
  const fieldColumn: IColumn[] = [
    {
      key: "column1",
      name: "Request",
      fieldName: "fieldname",
      minWidth: 30,
      maxWidth: 40,
      isRowHeader: true,
      isResizable: true,
      data: "string",
      isMultiline: true,
      sortAscendingAriaLabel: 'Sorted A to Z',
      sortDescendingAriaLabel: 'Sorted Z to A',
      isPadded: true,
      onRender: (item: any) => {
        return (
          <>
            <div>
              <Link onClick={() => addPlaceholders(item.key)}>
                {item.text}
              </Link>
            </div>
          </>
        );
      },
    }
  ];
  const counterColumn: IColumn[] = [
    {
      key: "column1",
      name: "Counterparty",
      fieldName: "Counterparty",
      minWidth: 30,
      maxWidth: 40,
      isRowHeader: true,
      isResizable: true,
      data: "string",
      isMultiline: true,
      sortAscendingAriaLabel: 'Sorted A to Z',
      sortDescendingAriaLabel: 'Sorted Z to A',
      isPadded: true,
      onRender: (item: any) => {
        return (
          <>
        <div>
          <Link onClick={() => addPlaceholders(item.key)}>
            {item.text}
          </Link>
        </div>
          </>
      );
    },
    }
  ];
  const OrgInfoColumn: IColumn[] = [
    {
      key: "column1",
      name: "OrganizationInfo",
      fieldName: "OrganizationInfo",
      minWidth: 30,
      maxWidth: 40,
      isRowHeader: true,
      isResizable: true,
      data: "string",
      isMultiline: true,
      sortAscendingAriaLabel: 'Sorted A to Z',
      sortDescendingAriaLabel: 'Sorted Z to A',
      isPadded: true,
      onRender: (item: any) => {
        return (
          <>
        <div>
          <Link onClick={() => addPlaceholders(item.key)}>
            {item.text}
          </Link>
        </div>
          </>
      );
    },
    }
  ];
  const addPlaceholders = async (Text: string) => {
    await Word.run(async (context) => {
      const formattedText = Text.replace(/ /g, '_');
      const doc = context.document;
      const range = doc.getSelection();
      const insertedRange = range.insertText(`#${formattedText}#`, Word.InsertLocation.replace);
      // await context.sync();
      const control = insertedRange.insertContentControl();      
      control.tag = formattedText;
      control.title = formattedText;
      control.appearance = "BoundingBox";
  
      await context.sync();
      // control.insertParagraph("", Word.InsertLocation.after);
      // await context.sync();
      // addPlaceholder(formattedText, control);
    });
  };
  
  const detailsLists = [
    {
      key: "showItems",
      items: showallplaceholder,
      columns: fieldColumn,
    },
    {
      key: "showCounterItems",
      items: showallcounterplaceholder,
      columns: counterColumn,
    },
    {
      key: "showOrgItems",
      items: showallOrgplaceholder,
      columns: OrgInfoColumn,
    },
  ];

  const customHeader = (props) => {
    return (
      <div className="CustomHeader">
        <DetailsHeader {...props} />
        {/* <IconButton
          iconProps={{ iconName: visibility?.[key] ? "ChevronDown" : "ChevronUp" }}
          onClick={() => {
            setVisibility((prev) => ({
              ...prev,
              [key]: !prev[key],
            }));
          }}
          title={visibility?.[key] ? "Hide items" : "Show items"}
        /> */}
      </div>
    );
  };
  const allItemsEmpty = detailsLists.every(({ key, items }) => !visibility[key] || items.length === 0);
  return (
    <div>
     {detailsLists.map(({ key, items, columns }) => (
      <DetailsList
        key={key}
        items={visibility[key] ? items : []}
        columns={columns.map(col => ({ ...col, isResizable: false,
        onRenderHeader: (props) => {
        const isCollapsed = visibility[key];
        return (
          <div className='CustomHeaderStyle'
           style={{width:allItemsEmpty ? '270px' : '260px'}}
          >
            <span>{props?.column.name}</span>
            {isCollapsed ? (
              <ChevronDownRegular className='ExpandTerms'  onClick={() => {
              setVisibility(prev => ({
                ...prev,
                [key]: !prev[key],
              }));
            }}/>
            ) : (
              <ChevronUpRegular className='ExpandTerms'  onClick={() => {
              setVisibility(prev => ({
                ...prev,
                [key]: !prev[key],
              }));
            }}/>
            )}
          </div>
        );
      },
    }))}
        setKey="set"
        selectionMode={SelectionMode.none}
        styles={customStyles}
        onRenderDetailsHeader={(props) => customHeader(props)}
      />
    ))}
   </div>         
  );
};

export default Terms;